module.exports = __webpack_public_path__ + "img/Slide17.4214a554.png";